import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import alertsReducer from './alertsReducer';
import availabilityReducer from './availabilityReducer';
import bookingsReducer from './bookingsReducer';
import filterReducer from './filterReducer';
import globalStatusReducer from './globalStatusReducer';
import issueDisputeReducer from './issueDisputeReducer';
import issuesReducer from './issuesReducer';
import issueTypesReducer from './issueTypesReducer';
import issueQuestionsReducer from './issueQuestionsReducer';
import modalsReducer from './modalsReducer';
import reservationsReducer from './reservationsReducer';
import servicesReducer from './servicesReducer';
import stripeCardReducer from './stripeCardReducer';
import stripeCouponReducer from './stripeCouponReducer';
import stripeCustomersReducer from './stripeCustomersReducer';
import stripePaymentReducer from './stripePaymentReducer';
import stripeProrationReducer from './stripeProrationReducer';
import stripeSubscriptionReducer from './stripeSubscriptionReducer';
import subscriptionReducer from './subscriptionReducer';
import teachersReducer from './teachersReducer';
import userReducer from './userReducer';

import metaReducer from './metaReducer';
import teacherReducer from './Teacher/teacherReducer';

// Admin
import adminIssuesReducer from './Admin/issuesReducer';
import adminAccountReducer from './Admin/accountReducer';
import adminAppointmentReducer from './Admin/appointmentReducer';
import refundStatusOptionsReducer from './Admin/refundStatusOptionsReducer';
import adminDisputesReducer from './Admin/disputesReducer';
import manageTeachersReducer from './Admin/manageTeachersReducer';

// properties will be attached to application state as state.<reducer>.<key>
// where <reducer> is defined here and <key> is defined in the reducer
// (state.auth.<key>: error, authenticated, etc as defined in the authReducer)
// eg: state.auth.authenticated
const reducers = {
  alerts: alertsReducer,
  availability: availabilityReducer,
  bookings: bookingsReducer,
  filters: filterReducer,
  form: formReducer,
  globalStatus: globalStatusReducer,
  issueDispute: issueDisputeReducer,
  issues: issuesReducer,
  issueTypes: issueTypesReducer,
  issueQuestions: issueQuestionsReducer,
  meta: metaReducer,
  reservations: reservationsReducer,
  services: servicesReducer,
  stripeCards: stripeCardReducer,
  stripeCoupon: stripeCouponReducer,
  stripeCustomer: stripeCustomersReducer,
  stripePayment: stripePaymentReducer,
  stripeProration: stripeProrationReducer,
  stripeSubscription: stripeSubscriptionReducer,
  subscription: subscriptionReducer,
  teachers: teachersReducer,
  user: userReducer,
  visibleModal: modalsReducer,

  // Teacher reducers
  teacher: teacherReducer,

  // Admin reducers
  accountResults: adminAccountReducer,
  appointment: adminAppointmentReducer,
  dispute: adminDisputesReducer,
  issueResults: adminIssuesReducer,
  refundStatusOptions: refundStatusOptionsReducer,
  teacherSearchResults: manageTeachersReducer
};

const rootReducer = combineReducers(reducers);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js